import * as marietta3d from '../..';
import { RoomPointArray } from '../utils';
import * as marietta from '../../../marietta';

/*
* 屋根辺属性 定数
*
*/
export const REDGE = {
  TORIAI: 0, /* 外壁取り合い */
  NOKI: 1, /* 軒先 */
  SUMI: 2, /* 隅棟 */
  TANI: 3, /* 谷 */
  MUNE: 4, /* 棟 */
  TUMA: 5, /* 妻 */
  UNKNOWN: -1,
};

/*
* コンストラクタ
*
* new AutoRoof();
*/
export class AutoObjRoof {
    public item: string;

    public index: number;

    public guid: string;

    public flr: number;

    public tsumade: number;

    public nokide: number;

    public height: number;

    public color: string;

    public points: RoomPointArray;

    public arrow: RoomPointArray;

    public depth: number;

    public slope: number;

    public baseP1: marietta.core.Point;

    public baseP2: marietta.core.Point;

    constructor() {
      this.item = '';
      this.index = 0;
      this.guid = marietta.webcad.WebCADGlobal.getGuid();
      this.height = 0;
      this.color = '#ccc';
      this.points = null;
      this.arrow = null;
      this.flr = 0;
      this.tsumade = 0;
      this.nokide = 0;
      this.slope = 0;
      this.baseP1 = null;
      this.baseP2 = null;
    }

    /*
    * 点が屋根の領域に含まれるとき true
    */
    public IsHit(p: marietta.core.Point): boolean {
      let rc: any;
      try {
        rc = this.points.IsInclude(p);
      } catch {
        // エラーに関係なく続行
      }
      if (rc === 1) {
        return true;
      }
      return false;
    }

    /*
    * 屋根の頂点座標をオフセットする
    */
    public Move(x: number, y: number) {
      this.points.Move(x, y);
    }

    /*
    * 描画
    */
    public draw(sc: marietta3d.AutoGen.Scale, ctx: CanvasRenderingContext2D): void {
      if (this.points.length > 1) {
        /*
                var clBlack = '#000';
                var clRed = '#f00';
                var clYellow = '#ff0';
                var clGreen = '#0f0';
                var clBlue = '#00f';
            */
        const clGray = '#ccc';
        const cl = clGray;

        ctx.strokeStyle = cl;
        ctx.lineWidth = 3;
        for (let i = 0; i < this.points.length; i += 1) {
          const ln = this.points.GetLine(i);
          ctx.strokeStyle = AutoObjRoof.edgeColor(ln.s.flag);
          ctx.beginPath();
          const s = sc.ConvertToCanvas(ln.s);
          const e = sc.ConvertToCanvas(ln.e);
          ctx.moveTo(s.x, s.y);
          ctx.lineTo(e.x, e.y);
          ctx.stroke();
        }
      }
    }

    /*
    * 屋根辺の属性ごとの色
    */
    public static edgeColor(edge: number): string {
      const clBlack = '#000';
      const clGray = '#ccc';
      const clRed = '#f00';
      const clYellow = '#ff0';
      const clGreen = '#0f0';
      const clBlue = '#00f';
      let cl = clGray;
      switch (edge) {
        case REDGE.TORIAI: cl = clBlack; break;
        case REDGE.NOKI: cl = clBlue; break;
        case REDGE.SUMI: cl = clGreen; break;
        case REDGE.TANI: cl = clYellow; break;
        case REDGE.MUNE: cl = clRed; break;
        case REDGE.TUMA: cl = clYellow; break;
        default: break;
      }
      return cl;
    }

    /*
    * 屋根XMLの読み込み
    */
    public readXML(item: Element): void {
      // item
      const rattr = item.attributes;
      this.flr = Number(rattr.getNamedItem('f').nodeValue);
      this.index = Number(rattr.getNamedItem('index').nodeValue);
      this.guid = rattr.getNamedItem('guid').nodeValue;
      this.tsumade = Number(rattr.getNamedItem('tsuma_de').nodeValue);
      this.nokide = Number(rattr.getNamedItem('noki_de').nodeValue);
      // this.item = rattr.getNamedItem( 'id' ).nodeValue;
      this.item = 'roof';
      // base
      const base = item.getElementsByTagName('base');
      const battr = base[0].attributes;
      this.slope = Number(battr.getNamedItem('slope').nodeValue);
      this.height = Number(battr.getNamedItem('height').nodeValue);
      const x1 = Number(battr.getNamedItem('x1').nodeValue);
      const y1 = Number(battr.getNamedItem('y1').nodeValue);
      const x2 = Number(battr.getNamedItem('x2').nodeValue);
      const y2 = Number(battr.getNamedItem('y2').nodeValue);
      this.baseP1 = new marietta.core.Point(x1, y1, 0);
      this.baseP2 = new marietta.core.Point(x2, y2, 0);

      // shape
      const shape = item.getElementsByTagName('shape');
      const points = shape[0].getElementsByTagName('point');
      const ary = new RoomPointArray();
      for (let j = 0; j < points.length; j += 1) {
        const pt = points[j].attributes;
        const ptx = Number(pt.getNamedItem('x').nodeValue);
        const pty = Number(pt.getNamedItem('y').nodeValue);
        // var ptz = Number( pt.getNamedItem( 'z' ).nodeValue );
        const type = pt.getNamedItem('type').nodeValue;
        const ptf = AutoObjRoof.GetRoofEdgeValueWebCAD(type);
        ary.Add(new marietta.core.Point(ptx, pty, ptf));
      }
      this.points = ary;

      // arrow
      const arrow = item.getElementsByTagName('arrow');
      const ary2 = new RoomPointArray();
      if (arrow.length > 0) {
        const points2 = arrow[0].getElementsByTagName('point');

        for (let j = 0; j < points2.length; j += 1) {
          const pt = points2[j].attributes;

          const ptx = Number(pt.getNamedItem('x').nodeValue);
          const pty = Number(pt.getNamedItem('y').nodeValue);
          const nodeType = pt.getNamedItem('draw');
          let tp = 0;
          if (nodeType != null) {
            tp = Number(nodeType.nodeValue);
          }
          ary2.Add(new marietta.core.Point(ptx, pty, tp));
        }
      }
      this.arrow = ary2;
    }

    /**
     *屋根JSONの読み込み
     * @param item
     */
    public readJson(item: any, buildingType:number = null): void {
      this.flr = Number(item.floor);
      this.index = Number(item.index);
      this.guid = item.guid;
      this.tsumade = Number(item.tsuma_de);
      this.nokide = Number(item.noki_de);
      // this.item = rattr.getNamedItem( 'id' ).nodeValue;
      this.item = 'roof';
      // base
      const baseData = item.base_line;
      this.slope = Number(item.slope);
      this.height = Number(item.height);
      let x1 = Number(baseData[0].x);
      let y1 = Number(baseData[0].y);
      let x2 = Number(baseData[1].x);
      let y2 = Number(baseData[1].y);
      if (buildingType !== null && buildingType === 1) {
        x1 = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(baseData[0].x));
        y1 = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(baseData[0].y));
        x2 = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(baseData[1].x));
        y2 = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(baseData[1].y));
      }
      this.baseP1 = new marietta.core.Point(x1, y1, 0);
      this.baseP2 = new marietta.core.Point(x2, y2, 0);

      // shape
      const shapeData = item.shape;
      const ary = new RoomPointArray();
      for (let j = 0; j < shapeData.length; j += 1) {
        let ptx = Number(shapeData[j].x);
        let pty = Number(shapeData[j].y);
        if (buildingType !== null && buildingType === 1) {
          ptx = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(shapeData[j].x));
          pty = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(shapeData[j].y));
        }
        // var ptz = Number( pt.getNamedItem( 'z' ).nodeValue );
        const type = shapeData[j].type_name;
        const ptf = AutoObjRoof.GetRoofEdgeValueWebCAD(type);
        ary.Add(new marietta.core.Point(ptx, pty, ptf));
      }
      this.points = ary;

      // arrow
      const { arrow } = item;
      const ary2 = new RoomPointArray();
      if (arrow.length > 0) {
        for (let j = 0; j < arrow.length; j += 1) {
          let ptx = Number(arrow[j].x);
          let pty = Number(arrow[j].y);
          if (buildingType !== null && buildingType === 1) {
            ptx = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(arrow[j].x));
            pty = marietta.webcad.util.WebCADUtil.convertMMToPix(Number(arrow[j].y));
          }
          const nodeType = arrow[j].draw;
          let tp = 0;
          if (nodeType != null) {
            tp = Number(arrow[j].draw);
          }
          ary2.Add(new marietta.core.Point(ptx, pty, tp));
        }
      }
      this.arrow = ary2;
    }

    /*
    * 桁（地回り）XMLの書き出し
    */
    public createXML(): string {
      let xml = '';
      xml = `${xml}<item f="${this.flr.toString()}" index="${this.index.toString()}" guid="${this.guid}" tsuma_de="${this.tsumade}" noki_de="${this.nokide}" >\n`;
      xml = `${xml}<base slope="${this.slope.toString()}" height="${this.height.toString()}" x1="${this.baseP1.x.toString()}" y1="${this.baseP1.y.toString()}" x2="${this.baseP2.x.toString()}" y2="${this.baseP2.y.toString()}" />\n`;
      xml += '<shape>\n';
      for (let i = 0; i < this.points.length; i += 1) {
        const p = this.points[i];
        const num = (i + 1).toString();
        xml = `${xml}<point type="${AutoObjRoof.GetRoofEdgeAttr(p.flag)}" index="${num}" x="${p.x.toString()}" y="${p.y.toString()}"/>\n`;
      }
      xml += '</shape>\n';
      xml += '</item>\n';
      return xml;
    }

    /*
    * 辺属性の文字列をコード化する(手入力屋根の入力画面への戻し)
    */
    public static GetRoofEdgeValueWebCAD(attr: string): number {
      let val: number;
      switch (attr) {
        case 'toriai': val = 0; break;
        case 'noki': val = 0; break;
        case 'sumi': val = 0; break;
        case 'tani': val = 0; break;
        case 'mune': val = 0; break;
        case 'tuma': val = 1; break;
        default: break;
      }
      return val;
    }

    /*
    * 辺属性の文字列をコード化する
    */
    public static GetRoofEdgeValue(attr: string): number {
      let val: number;
      switch (attr) {
        case 'toriai': val = REDGE.TORIAI; break;
        case 'noki': val = REDGE.NOKI; break;
        case 'sumi': val = REDGE.SUMI; break;
        case 'tani': val = REDGE.TANI; break;
        case 'mune': val = REDGE.MUNE; break;
        case 'tuma': val = REDGE.TUMA; break;
        default: break;
      }
      return val;
    }

    /*
    * 指定された辺属性値を文字列で返す
    */
    public static GetRoofEdgeAttr(attr: number): string {
      let str: string;
      switch (attr) {
        case REDGE.TORIAI: str = 'toriai'; break;
        case REDGE.NOKI: str = 'noki'; break;
        case REDGE.SUMI: str = 'sumi'; break;
        case REDGE.TANI: str = 'tani'; break;
        case REDGE.MUNE: str = 'mune'; break;
        case REDGE.TUMA: str = 'tuma'; break;
        default: break;
      }
      return str;
    }
}

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
export class AutoObjRoofCut {
  public index: number;

  public guid: string;

  public width: string;

  public depth: string;

  public p: marietta.core.Point;

  constructor() {
    this.index = 0;
    this.guid = marietta.webcad.WebCADGlobal.getGuid();
    this.p = new marietta.core.Point(0, 0, 0);
    this.width = '0';
    this.depth = '0';
  }

  /*
  * Roof CUT XMLの読み込み
  */
  public readXML(item: Element): void {
    // item
    const rattr = item.attributes;
    this.index = Number(rattr.getNamedItem('index').nodeValue);
    const nodeGuid = rattr.getNamedItem('guid');
    if (nodeGuid != null) {
      this.guid = nodeGuid.nodeValue;
    }
    const nodeX = rattr.getNamedItem('x');
    if (nodeX != null) {
      this.p.x = Number(nodeX.nodeValue);
    }
    const nodeY = rattr.getNamedItem('y');
    if (nodeY != null) {
      this.p.y = Number(nodeY.nodeValue);
    }
    const nodeWidth = rattr.getNamedItem('width');
    if (nodeWidth != null) {
      this.width = nodeWidth.nodeValue;
    }
    const nodeDepth = rattr.getNamedItem('depth');
    if (nodeDepth != null) {
      this.depth = nodeDepth.nodeValue;
    }
  }

  /*
  * Roof CUT XMLの書き出し
  */
  public createXML(/* cnt: number */): string {
    let xml = '';
    xml = `${xml}<item index="${this.index.toString()}" x="${this.p.x.toString()}" y="${this.p.y.toString()}" width="${this.width}" depth="${this.depth}" />\n`;
    return xml;
  }

  /*
  * Roof CUT XMLの書き出し
  */
  public createXML2(doc: Document, node: Element/* , cnt: number */): void {
    const nodeItem = doc.createElement('item');
    node.appendChild(nodeItem);

    nodeItem.setAttribute('index', this.index.toString());
    nodeItem.setAttribute('x', this.p.x.toString());
    nodeItem.setAttribute('y', this.p.y.toString());
    nodeItem.setAttribute('width', this.width);
    nodeItem.setAttribute('depth', this.depth);
  }
}

/** **************************************************** */
/** **************************************************** */
/** **************************************************** */
export class AutoObjRoofAdd {
  public index: number;

  public guid: string;

  public width: string;

  public depth: string;

  public p: marietta.core.Point;

  constructor() {
    this.index = 0;
    this.guid = marietta.webcad.WebCADGlobal.getGuid();
    this.p = new marietta.core.Point(0, 0, 0);
    this.width = '0';
    this.depth = '0';
  }

  /*
  * Roof ADD XMLの読み込み
  */
  public readXML(item: Element): void {
    // item
    const rattr = item.attributes;
    this.index = Number(rattr.getNamedItem('index').nodeValue);
    const nodeGuid = rattr.getNamedItem('guid');
    if (nodeGuid != null) {
      this.guid = nodeGuid.nodeValue;
    }
    const nodeX = rattr.getNamedItem('x');
    if (nodeX != null) {
      this.p.x = Number(nodeX.nodeValue);
    }
    const nodeY = rattr.getNamedItem('y');
    if (nodeY != null) {
      this.p.y = Number(nodeY.nodeValue);
    }
    const nodeWidth = rattr.getNamedItem('width');
    if (nodeWidth != null) {
      this.width = nodeWidth.nodeValue;
    }
    const nodeDepth = rattr.getNamedItem('depth');
    if (nodeDepth != null) {
      this.depth = nodeDepth.nodeValue;
    }
  }

  /*
  * Roof ADD XMLの書き出し
  */
  public createXML(/* cnt: number */): string {
    let xml = '';
    xml = `${xml}<item index="${this.index.toString()}" x="${this.p.x.toString()}" y="${this.p.y.toString()}" width="${this.width}" depth="${this.depth}" />\n`;
    return xml;
  }

  /*
  * Roof ADD XMLの書き出し
  */
  public createXML2(doc: Document, node: Element /* cnt: number */) {
    const nodeItem = doc.createElement('item');
    node.appendChild(nodeItem);
    nodeItem.setAttribute('index', this.index.toString());
    nodeItem.setAttribute('x', this.p.x.toString());
    nodeItem.setAttribute('y', this.p.y.toString());
    nodeItem.setAttribute('width', this.width);
    nodeItem.setAttribute('depth', this.depth);
  }
}

/*
* コンストラクタ
*
* ;
*/
export class AutoObjKeta {
    public index: number;

    public guid: string;

    public flr: number;

    public tsumade: string;

    public nokide: string;

    public slope: string;

    public baseHigh: string;

    public type: string;

    public nagare: string;

    public points: RoomPointArray;

    public roofCut: Array<AutoObjRoofCut>;

    public roofAdd: Array<AutoObjRoofAdd>;

    constructor() {
      this.index = 0;
      this.guid = marietta.webcad.WebCADGlobal.getGuid();
      this.points = null;
      this.flr = 0;
      this.tsumade = '0';
      this.nokide = '0';
      this.slope = '4.5';
      this.baseHigh = '0';
      this.type = '0';
      this.nagare = '0';

      this.roofCut = null;
      this.roofAdd = null;
    }

    /*
    * 桁（地回り）XMLの読み込み
    */
    public readXML(item: Element): void {
      // item
      const rattr = item.attributes;

      const nodeFlr = rattr.getNamedItem('f');
      if (nodeFlr != null) {
        this.flr = Number(nodeFlr.nodeValue);
      }
      const nodeIdx = rattr.getNamedItem('index');
      if (nodeIdx != null) {
        this.index = Number(nodeIdx.nodeValue);
      }

      const nodeGuid = rattr.getNamedItem('guid');
      if (nodeGuid != null) {
        this.guid = nodeGuid.nodeValue;
      }
      const nodeRType = rattr.getNamedItem('type');
      if (nodeRType != null) {
        if ((nodeRType.nodeValue === '1')
                || (nodeRType.nodeValue === '2')
                || (nodeRType.nodeValue === '3')
                || (nodeRType.nodeValue === '6')) {
          this.type = nodeRType.nodeValue;
        } else {
          this.type = '1';
        }
      }
      const nodeSlope = rattr.getNamedItem('slope');
      if (nodeSlope != null) {
        this.slope = nodeSlope.nodeValue;
      } else if (this.type === '2') {
        this.slope = '1.5';
      }
      const nodeBaseHigh = rattr.getNamedItem('nokidaka_offset');
      if (nodeBaseHigh != null) {
        this.baseHigh = nodeBaseHigh.nodeValue;
      }
      const nodeTuma = rattr.getNamedItem('tsuma_de');
      if (nodeTuma != null) {
        this.tsumade = nodeTuma.nodeValue;
      }
      const nodeNoki = rattr.getNamedItem('noki_de');
      if (nodeNoki != null) {
        this.nokide = nodeNoki.nodeValue;
      }
      const nodeNagare = rattr.getNamedItem('direction_type');
      if (nodeNagare != null) {
        if ((nodeNagare.nodeValue === '1') || (nodeNagare.nodeValue === '2') || (nodeNagare.nodeValue === '3') || (nodeNagare.nodeValue === '4')) {
          this.nagare = nodeNagare.nodeValue;
        } else {
          this.nagare = '2';
        }
      }

      // shape
      const shape = item.getElementsByTagName('shape');
      const ary = new RoomPointArray();
      if (shape.length > 0) {
        const points = shape[0].getElementsByTagName('point');

        for (let j = 0; j < points.length; j += 1) {
          const pt = points[j].attributes;

          const ptx = Number(pt.getNamedItem('x').nodeValue);
          const pty = Number(pt.getNamedItem('y').nodeValue);
          const nodeType = pt.getNamedItem('type');
          let tp = 0;
          if (nodeType != null) {
            if ((nodeType.nodeValue === '0') || (nodeType.nodeValue === '1')) {
              tp = Number(nodeType.nodeValue);
            }
          }
          ary.Add(new marietta.core.Point(ptx, pty, tp));
        }
      }
      this.points = ary;

      // RoofCut
      const cut = item.getElementsByTagName('cut');
      if (cut.length > 0) {
        const items = cut[0].getElementsByTagName('item');

        this.roofCut = [];
        for (let i2 = 0; i2 < items.length; i2 += 1) {
          const objCut = new AutoObjRoofCut();
          objCut.readXML(items[i2]);
          this.roofCut.push(objCut);
        }
      }
      // RoofAdd
      const add = item.getElementsByTagName('add');
      if (add.length > 0) {
        const items = add[0].getElementsByTagName('item');
        this.roofAdd = [];
        for (let i2 = 0; i2 < items.length; i2 += 1) {
          const objAdd = new AutoObjRoofCut();
          objAdd.readXML(items[i2]);
          this.roofAdd.push(objAdd);
        }
      }
    }

    /*
    * 桁（地回り）XMLの読み込み
    */
    public readJson(item: any): void {
      const nodeFlr = item.f;
      if (nodeFlr != null) {
        this.flr = Number(nodeFlr);
      }
      const nodeIdx = item.index;
      if (nodeIdx != null) {
        this.index = Number(nodeIdx);
      }

      const nodeGuid = item.guid;
      if (nodeGuid != null) {
        this.guid = nodeGuid;
      }
      const nodeRType = item.type;
      if (nodeRType != null) {
        if ((nodeRType === '1')
                || (nodeRType === '2')
                || (nodeRType === '3')
                || (nodeRType === '6')) {
          this.type = nodeRType;
        } else {
          this.type = '1';
        }
      }
      const nodeSlope = item.slope;
      if (nodeSlope != null) {
        this.slope = nodeSlope;
      } else if (this.type === '2') {
        this.slope = '1.5';
      }
      const nodeBaseHigh = item.nokidaka_offset;
      if (nodeBaseHigh != null) {
        this.baseHigh = nodeBaseHigh;
      }
      const nodeTuma = item.tsuma_de;
      if (nodeTuma != null) {
        this.tsumade = nodeTuma;
      }
      const nodeNoki = item.noki_de;
      if (nodeNoki != null) {
        this.nokide = nodeNoki;
      }
      const nodeNagare = item.direction;
      if (nodeNagare != null) {
        if ((nodeNagare === '1') || (nodeNagare === '2') || (nodeNagare === '3') || (nodeNagare === '4')) {
          this.nagare = nodeNagare;
        } else {
          this.nagare = '2';
        }
      }

      // shape
      const shapeData = item.shape;
      const ary = new RoomPointArray();
      if (shapeData.length > 0) {
        for (let j = 0; j < shapeData[j].length; j += 1) {
          const ptx = Number(shapeData[j].x);
          const pty = Number(shapeData[j].y);
          const nodeType = shapeData[j].type;
          let tp = 0;
          if (nodeType != null) {
            if ((nodeType === '0') || (nodeType === '1')) {
              tp = Number(nodeType);
            }
          }
          ary.Add(new marietta.core.Point(ptx, pty, tp));
        }
      }
      this.points = ary;
    }

    /*
    * 桁（地回り）XMLの書き出し
    */
    public createXML(/* cnt: number */): string {
      let xml = '';
      xml = `${xml}<item f="${this.flr.toString()}" index="${this.index.toString()}" guid="${this.guid}" slope="${this.slope}" nokidaka_offset="${this.baseHigh}" tsuma_de="${this.tsumade}" noki_de="${this.nokide}" type="${this.type}" direction_type="${this.nagare}" >\n`;
      xml += '<shape>\n';
      for (let i = 0; i < this.points.length; i += 1) {
        const p = this.points[i];
        const num = (i + 1).toString();
        xml = `${xml}<point type="${p.flag.toString()}" index="${num}" x="${p.x.toString()}" y="${p.y.toString()}"/>\n`;
      }
      xml += '</shape>\n';
      if (this.roofCut != null) {
        xml += '<cut>\n';
        for (let i = 0; i < this.roofCut.length; i += 1) {
          xml += this.roofCut[i].createXML(/* i + 1 */);
        }
        xml += '</cut>\n';
      }
      if (this.roofAdd != null) {
        xml += '<add>\n';
        for (let i = 0; i < this.roofAdd.length; i += 1) {
          xml += this.roofAdd[i].createXML(/* i + 1 */);
        }
        xml += '</add>\n';
      }
      xml += '</item>\n';
      return xml;
    }

    /*
    * 桁（地回り）XMLの書き出し
    */
    public createXML2(doc: Document, node: Element/* , cnt: number */): void {
      const nodeItem = doc.createElement('item');
      node.appendChild(nodeItem);

      nodeItem.setAttribute('f', this.flr.toString());
      nodeItem.setAttribute('index', this.index.toString());
      nodeItem.setAttribute('guid', this.guid);
      nodeItem.setAttribute('slope', this.slope);
      nodeItem.setAttribute('nokidaka_offset', this.baseHigh);
      nodeItem.setAttribute('tsuma_de', this.tsumade);
      nodeItem.setAttribute('noki_de', this.nokide);
      nodeItem.setAttribute('type', this.type);
      nodeItem.setAttribute('direction_type', this.nagare);

      const nodeShape = doc.createElement('shape');
      nodeItem.appendChild(nodeShape);

      for (let i = 0; i < this.points.length; i += 1) {
        const p = this.points[i];
        const num = (i + 1).toString();
        const nodeP = doc.createElement('point');
        nodeShape.appendChild(nodeP);

        nodeP.setAttribute('index', num);
        nodeP.setAttribute('type', p.flag.toString());
        nodeP.setAttribute('x', p.x.toString());
        nodeP.setAttribute('y', p.y.toString());
      }
      if (this.roofCut != null) {
        const nodeCut = doc.createElement('cut');
        nodeItem.appendChild(nodeCut);

        for (let i = 0; i < this.roofCut.length; i += 1) {
          this.roofCut[i].createXML2(doc, nodeCut/* , i + 1 */);
        }
      }
      if (this.roofAdd != null) {
        const nodeAdd = doc.createElement('add');
        nodeItem.appendChild(nodeAdd);

        for (let i = 0; i < this.roofAdd.length; i += 1) {
          this.roofAdd[i].createXML2(doc, nodeAdd/* , i + 1 */);
        }
      }
    }
}
